import { useSelector } from "react-redux";
import useClientContext from "../../../../contexts/useClientContext";
import useClientPageTitle from "../../../../contexts/useClientPageTitle";
import { workspaceInvestorSelector } from "../../../../store/state/user/selectors";
import SettingsWrapper from "../SettingsWrapper";
import EditAccountSettings from "./EditAccountSettings";

export const AccountSettings = () => {
  useClientPageTitle("Investor Details");

  const { isFeatureEnabled } = useClientContext();
  const workspaceInvestor = useSelector(workspaceInvestorSelector);

  const canUserEdit = isFeatureEnabled("AccountSettingsEditor");

  return (
    <SettingsWrapper title="Investor Details" subtitle={workspaceInvestor?.investorTitle} scrollOwner="wrapper">
      {workspaceInvestor && (
        <EditAccountSettings
          key={workspaceInvestor.investorId}
          canUserEdit={canUserEdit}
          investorId={workspaceInvestor.investorId}
        />
      )}
    </SettingsWrapper>
  );
};

export default AccountSettings;
